// Grössen-Buttons: Grid-Spalten dynamisch auf Anzahl Buttons setzen
function initSwatchGrid() {
  document.querySelectorAll('.block-swatch-list').forEach(function(list) {
    var count = list.querySelectorAll('.block-swatch').length;
    list.style.setProperty('--swatch-count', count);
  });
}

document.addEventListener('DOMContentLoaded', initSwatchGrid);

// Auch nach Variant-Wechsel neu initialisieren (falls Shopify die Liste neu rendert)
document.addEventListener('variant:changed', initSwatchGrid);


/* ===================================================================
   MERKLISTE (Stufe 1) + UMTAUSCH-HINWEIS — 3RD MAY, 10./11.09.2026

   Shopify hat keine eingebaute Merkliste. Diese Fassung speichert im
   Browser des Besuchers (localStorage), braucht also weder Login noch
   App noch Server. Grenze: gilt pro Gerät und Browser.

   NUR AUF DER PRODUKTSEITE, bewusst nicht auf den Kachelrastern
   (Entscheid Patrick, 11.09.2026). Zalando und About You setzen das Herz
   auf die Kachel, weil man dort durch tausende Artikel scrollt und im
   Vorbeigehen parken will. 3RD MAY hat 46 Produkte — es gibt kein Raster
   zum Aussortieren, und auf den ruhigen Freistellern ist ein schwebendes
   Herz Störung ohne Gegenwert. SNOCKS, ein vergleichbarer Direktvertrieb,
   hat gar keine Merkliste (am 11.09.2026 geprüft: null Treffer).

   Stufe 2 (am Kundenkonto, geräteübergreifend) würde nur SPEICHERN und
   LADEN ersetzen — die beiden Funktionen unten sind bewusst die einzige
   Stelle, die dann angefasst werden muss.

   Warum hier und nicht in theme.liquid: custom.js wird auf jeder Seite
   geladen und ist klein. Ein Eingriff in die 62-KB-theme.liquid wäre
   dasselbe Ergebnis bei erheblich mehr Risiko.

   KEINE BACKSLASHES IN DIESER DATEI. Sie geht über die Theme-API hoch,
   und ein Backslash überlebt den Weg nicht — die ganze Datei stirbt dann
   am Syntaxfehler, samt initSwatchGrid oben. Am 10.09. mit einem Regex
   passiert. Also: keine regulären Ausdrücke, keine maskierten Zeichen.
   =================================================================== */
(function () {
  'use strict';

  var SCHLUESSEL = '3rdmay_merkliste';
  var SEITE = '/pages/merkliste';
  var RETOUREN = '/pages/shipments-returns';

  // --- Speicher (Stufe 2 tauscht genau diese zwei Funktionen) ---------
  function laden() {
    try {
      var roh = window.localStorage.getItem(SCHLUESSEL);
      var liste = roh ? JSON.parse(roh) : [];
      return Array.isArray(liste) ? liste.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return [];   // privater Modus, blockierte Speicherung, kaputter Inhalt
    }
  }

  function speichern(liste) {
    try {
      window.localStorage.setItem(SCHLUESSEL, JSON.stringify(liste));
    } catch (e) {
      /* Kein Speicher verfügbar: die Merkliste bleibt für diese Sitzung im DOM,
         geht aber beim Neuladen verloren. Besser als eine Fehlermeldung. */
    }
    document.dispatchEvent(new CustomEvent('merkliste:geaendert', { detail: liste }));
  }

  function gemerkt(handle) { return laden().indexOf(handle) !== -1; }

  function umschalten(handle) {
    var liste = laden();
    var i = liste.indexOf(handle);
    if (i === -1) { liste.push(handle); } else { liste.splice(i, 1); }
    speichern(liste);
    return i === -1;
  }

  // --- Hilfen ---------------------------------------------------------
  function handleAus(url) {
    if (!url) return null;
    var s = String(url);
    var i = s.indexOf('/products/');
    if (i === -1) return null;
    var rest = s.slice(i + 10);
    rest = rest.split('?')[0].split('#')[0].split('/')[0];
    return rest ? decodeURIComponent(rest) : null;
  }

  function herzSvg(gefuellt) {
    return '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">'
      + '<path d="M12 20.7 4.2 13a4.8 4.8 0 0 1 0-6.8 4.8 4.8 0 0 1 6.8 0l1 1 1-1a4.8 4.8 0 0 1 6.8 0 '
      + '4.8 4.8 0 0 1 0 6.8Z" fill="' + (gefuellt ? 'currentColor' : 'none')
      + '" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
  }

  function knopfBauen(handle, klasse) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mk-herz ' + (klasse || '');
    b.setAttribute('data-mk-handle', handle);
    zeichnen(b, gemerkt(handle));
    return b;
  }

  function zeichnen(knopf, an) {
    knopf.innerHTML = herzSvg(an);
    knopf.setAttribute('aria-pressed', an ? 'true' : 'false');
    knopf.setAttribute('aria-label', an ? 'Von der Merkliste entfernen' : 'Auf die Merkliste');
    knopf.setAttribute('title', an ? 'Von der Merkliste entfernen' : 'Auf die Merkliste');
    knopf.classList.toggle('is-an', an);
  }

  /* --- Die richtige Kaufleiste finden ---------------------------------

     Die PDP hat ZWEI Elemente mit .product-form__add-button: eines im
     Hauptformular und eines in der klebenden Leiste, die erst beim Scrollen
     erscheint. querySelector nimmt die klebende zuerst — dort landeten Herz
     und Umtauschzeile bis zum 11.09.2026 unsichtbar (visibility:hidden,
     Breite 0). Deshalb wird die klebende Leiste hier ausdrücklich
     uebersprungen. */
  function pdpZeile() {
    if (location.pathname.indexOf('/products/') === -1) return null;
    var knoepfe = document.querySelectorAll('.product-form__add-button');
    for (var i = 0; i < knoepfe.length; i++) {
      var k = knoepfe[i];
      if (k.closest('product-sticky-form, .product-sticky-form, .ed-product-sticky-form')) continue;
      var reihe = k.closest('.product-form__buy-buttons')
               || k.closest('.product-form__buttons')
               || k.parentElement;
      if (reihe && reihe.parentElement) return reihe;
    }
    return null;
  }

  function herzAufPdp() {
    if (document.querySelector('.mk-herz--pdp')) return;
    var reihe = pdpZeile();
    if (!reihe) return;
    var handle = handleAus(location.pathname);
    if (!handle) return;

    var zeile = document.createElement('div');
    zeile.className = 'mk-pdp-zeile';
    var b = knopfBauen(handle, 'mk-herz--pdp');
    var text = document.createElement('span');
    text.className = 'mk-pdp-text';
    text.textContent = gemerkt(handle) ? 'Auf Deiner Merkliste' : 'Für später merken';
    zeile.appendChild(b);
    zeile.appendChild(text);
    reihe.parentElement.insertBefore(zeile, reihe.nextSibling);
  }

  /* Umtausch-Hinweis auf der Produktseite.

     Warum hier: das Retourenportal war bisher nur aus der FAQ und der
     Versandseite verlinkt. Wer vor einem teuren Strickteil zwischen L und XL
     schwankt, liest aber keine FAQ — der Zweifel entsteht am Kaufbutton, also
     gehoert die Antwort dorthin. Bewusst OHNE das Wort "kostenlos": das
     Rueckporto zahlt der Kunde, versprochen wird nur die einfache Abwicklung. */
  function umtauschHinweis() {
    if (document.querySelector('.mk-umtausch')) return;
    var zeile = document.querySelector('.mk-pdp-zeile') || pdpZeile();
    if (!zeile || !zeile.parentElement) return;
    var p = document.createElement('p');
    p.className = 'mk-umtausch';
    p.innerHTML = '<strong>Grösse unsicher?</strong> Umtausch in zwei Minuten angemeldet – '
      + 'die neue Grösse geht sofort raus. '
      + '<a href="' + RETOUREN + '">So funktioniert es</a>';
    zeile.parentElement.insertBefore(p, zeile.nextSibling);
  }

  // --- Zähler im Kopf ---------------------------------------------------
  function zaehlerSetzen() {
    var n = laden().length;
    var link = document.querySelector('.mk-kopf-link');
    if (!link) {
      var warenkorb = document.querySelector('a[href="/cart"]');
      if (!warenkorb || !warenkorb.parentElement) return;
      link = document.createElement('a');
      link.className = 'mk-kopf-link';
      link.href = SEITE;
      link.setAttribute('aria-label', 'Merkliste');
      warenkorb.parentElement.insertBefore(link, warenkorb);
    }
    link.innerHTML = herzSvg(n > 0) + (n > 0 ? '<span class="mk-zahl">' + n + '</span>' : '');
    link.style.display = n > 0 ? '' : 'none';   // erst zeigen, wenn etwas drin ist
  }

  // --- Die Merklisten-Seite ---------------------------------------------
  function seiteFuellen() {
    var ziel = document.getElementById('merkliste');
    if (!ziel) return;
    var liste = laden();
    if (!liste.length) {
      ziel.innerHTML = '<p class="mk-leer">Deine Merkliste ist noch leer. '
        + 'Tippe auf der Produktseite auf das Herz, dann findest Du den Artikel hier wieder.</p>'
        + '<p><a class="button button--primary" href="/collections/all">Zu den Produkten</a></p>';
      return;
    }
    ziel.innerHTML = '<p class="mk-leer">Einen Moment …</p>';
    Promise.all(liste.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (produkte) {
      var gueltig = [];
      var html = '';
      produkte.forEach(function (p, i) {
        if (!p) return;                       // Produkt gelöscht -> still aus der Liste
        gueltig.push(liste[i]);
        var bild = p.featured_image ? p.featured_image + '&width=600' : '';
        var preis = (p.price / 100).toFixed(2);
        var titelSicher = String(p.title).split('"').join('&quot;');
        html += '<article class="mk-eintrag">'
          + '<a href="/products/' + p.handle + '">'
          + (bild ? '<img src="' + bild + '" alt="' + titelSicher + '" loading="lazy">' : '')
          + '</a>'
          + '<div class="mk-eintrag__text">'
          + '<a class="mk-eintrag__titel" href="/products/' + p.handle + '">' + p.title + '</a>'
          + '<span class="mk-eintrag__preis">CHF ' + preis + '</span>'
          + '<button type="button" class="mk-entfernen" data-mk-handle="' + p.handle + '">Entfernen</button>'
          + '</div></article>';
      });
      if (gueltig.length !== liste.length) speichern(gueltig);
      ziel.innerHTML = html || '<p class="mk-leer">Deine gemerkten Artikel sind nicht mehr verfügbar.</p>';
    });
  }

  // --- Stil (hier statt in custom.css, damit nur eine Datei berührt wird) ---
  function stil() {
    if (document.getElementById('mk-stil')) return;
    var s = document.createElement('style');
    s.id = 'mk-stil';
    s.textContent = [
      '.mk-herz{background:none;border:0;padding:6px;cursor:pointer;color:inherit;line-height:0;',
      '  transition:transform .15s ease}',
      '.mk-herz:hover{transform:scale(1.12)}',
      '.mk-herz.is-an{color:#801818}',
      '.mk-pdp-zeile{display:flex;align-items:center;gap:.4rem;margin:.75rem 0 0}',
      '.mk-pdp-text{font-size:.9rem}',
      '.mk-umtausch{font-size:.85rem;line-height:1.45;margin:.5rem 0 0;opacity:.85}',
      '.mk-umtausch a{text-decoration:underline;text-underline-offset:3px;color:inherit}',
      '.mk-kopf-link{display:inline-flex;align-items:center;gap:.25rem;color:inherit;position:relative}',
      '.mk-zahl{font-size:.75rem;line-height:1}',
      '.mk-eintrag{display:flex;gap:1rem;padding:1rem 0;border-bottom:1px solid #d3d2cb}',
      '.mk-eintrag img{width:110px;height:auto;display:block}',
      '.mk-eintrag__text{display:flex;flex-direction:column;gap:.3rem;justify-content:center}',
      '.mk-eintrag__titel{font-weight:600;text-decoration:none;color:inherit}',
      '.mk-entfernen{align-self:flex-start;background:none;border:0;padding:0;cursor:pointer;',
      '  text-decoration:underline;font-size:.85rem;color:inherit}',
      '.mk-leer{margin:1.5rem 0}',
      '@media(max-width:480px){.mk-eintrag img{width:84px}}'
    ].join('');
    document.head.appendChild(s);
  }

  // --- Verdrahtung -------------------------------------------------------
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var herz = e.target.closest('.mk-herz');
    if (herz) {
      e.preventDefault();
      e.stopPropagation();
      var h = herz.getAttribute('data-mk-handle');
      var an = umschalten(h);
      document.querySelectorAll('.mk-herz').forEach(function (k) {
        if (k.getAttribute('data-mk-handle') === h) zeichnen(k, an);
      });
      var t = document.querySelector('.mk-pdp-text');
      if (t && herz.classList.contains('mk-herz--pdp')) {
        t.textContent = an ? 'Auf Deiner Merkliste' : 'Für später merken';
      }
      return;
    }
    var weg = e.target.closest('.mk-entfernen');
    if (weg) {
      umschalten(weg.getAttribute('data-mk-handle'));
      seiteFuellen();
    }
  });

  document.addEventListener('merkliste:geaendert', zaehlerSetzen);

  function start() {
    stil();
    herzAufPdp();
    umtauschHinweis();
    zaehlerSetzen();
    seiteFuellen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();